import React, { ForwardRefExoticComponent, PropsWithoutRef, RefAttributes } from 'react'
import { Link, LinkProps } from 'react-router-dom'
import { useButtonClassName } from './useButtonClassName'
import { Button, ButtonVariant } from './Button'

export interface LinkButtonProps extends LinkProps {
  variant?: ButtonVariant
  disabled?: boolean
}

export const LinkButton: ForwardRefExoticComponent<PropsWithoutRef<LinkButtonProps> & RefAttributes<HTMLAnchorElement>> = React.forwardRef<
  HTMLAnchorElement,
  LinkButtonProps
>(({ variant, className, children, disabled, ...rest }, ref) => {
  const linkClassName = useButtonClassName(variant, className)
  return (
    <>
      {disabled ? (
        <Button variant={variant} className={className} disabled>
          {children}
        </Button>
      ) : (
        <Link ref={ref} className={linkClassName} {...rest}>
          {children}
        </Link>
      )}
    </>
  )
})
